import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTipComponent } from './rx-tip.component';

@NgModule({
  imports: [CommonModule, RxIconModule, RxTipComponent],
  exports: [RxTipComponent],
})
export class RxTipModule {}
